module.exports = __webpack_public_path__ + "src/assets/img/bg4.f55c7e34.jpg";